// Copyright (c) 2026, ECOSIRE (PRIVATE) LIMITED and contributors
// For license information, please see license.txt
//
// Web/portal-side brand enhancements. On the login page (a guest web page with no
// desk boot payload) it injects the configured heading / subtext / footer around
// the login card. Backgrounds + custom CSS arrive via web_include_css (brand_css).

(function () {
	function onLoginPage() {
		return /(^|\/)login(\?|$|#)/.test(window.location.pathname + window.location.search)
			|| document.querySelector(".for-login, .page-card");
	}

	function injectLoginBranding(data) {
		if (!data) return;
		const card = document.querySelector(".page-card");
		if (!card) return;

		if (data.logo) {
			// Dedicated login logo overrides the app logo on the login card.
			document.querySelectorAll("img.app-logo").forEach((img) => {
				img.src = data.logo;
			});
		}

		if (data.heading) {
			let head = card.querySelector(".page-card-head");
			if (!head) {
				head = document.createElement("div");
				head.className = "page-card-head";
				card.insertBefore(head, card.firstChild);
			}
			const h = document.createElement("div");
			h.className = "ecosire-login-heading";
			h.textContent = data.heading;
			head.appendChild(h);
		}
		if (data.subtext) {
			const p = document.createElement("p");
			p.className = "ecosire-login-subtext text-muted";
			p.textContent = data.subtext;
			card.insertBefore(p, card.querySelector(".page-card-body") || null);
		}
		if (data.footer) {
			const f = document.createElement("div");
			f.className = "ecosire-login-footer text-muted text-center";
			f.textContent = data.footer;
			card.appendChild(f);
		}
	}

	if (!onLoginPage()) return;

	fetch("/api/method/ecosire_branding.branding.login.login_branding", {
		headers: { Accept: "application/json" },
		credentials: "same-origin",
	})
		.then((r) => r.json())
		.then((res) => injectLoginBranding(res && res.message))
		.catch(() => {});
})();
